import React, { useState, useRef, useMemo } from "react";
import { Navbar, Nav, Dropdown } from "react-bootstrap";
import { FaLaptop, FaBolt, FaWindows, FaBars } from "react-icons/fa";
import { useProductFilter } from "../../context/ProductFilterContext";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CustomNavbar.css";

const CustomNavbar = () => {
  const { setFilterCategory, setFilterSubcategory } = useProductFilter();
  const [isPanelVisible, setPanelVisible] = useState(false);
  const [openCategory, setOpenCategory] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const categories = useMemo(() => ({
    "Electrodomésticos": ["Pequenos Domésticos", "Climatização", "Iluminação", "Extensões e Ladrões", "Aquecimento de Água", "Outros"],
    "Energia": ["Cabos", "Adaptadores e Alimentação", "Acessórios", "Conversores de Energia", "Estabilizadores", "UPS - Sistemas de Alimentação Ininterrupta", "Baterias"],
    "Imagem e Som": ["Colunas", "Rádios, Leitores e Gravadores", "Auscultadores", "Acessórios", "Projetores"],
    "Impressão": ["Impressoras Matriciais", "Impressoras Laser", "Fontes de Alimentação", "Acessórios", "Toners e Tinteiros", "Peças"],
    "Informática": ["Dock Stations e HUBs", "Pastas, Mochilas e Outros", "Teclados e Ratos", "Laptops", "Armazenamento", "Monitores", "Acessórios", "Fontes de Alimentação"],
    "Material de Escritório e Escolar": ["Encadernação", "Artigos de Escritório e Escolares", "Papelaria", "Consumíveis"],
    "Redes, Internet e Telecomunicações": ["Cabos de Rede", "Armários/ Bastidores", "Routers e Switches", "Ferramentas de Rede", "Telefones", "Acessórios", "Outros"],
    "Segurança Electrónica": ["Videovigilância - Câmaras IP", "Videovigilância - Gravadores", "Acessórios", "Alarmes", "Controlo de Acessos"],
    "Smartphones, Tablets e Telemóveis": ["Smartphones", "Acessórios", "Peças", "Ferramentas e Equipamento Técnico", "Cartões SIM"],
    "Software": ["Kaspersky", "Windows Server", "Windows OS", "Office", "Outros"]
  }), []);

  const navbarCategories = useMemo(() => Object.keys(categories).slice(0, 5), [categories]);
  const panelCategories = Object.keys(categories);

  const renderIcon = (category) => {
    switch (category) {
      case "Informática": return <FaLaptop className="nav-icon" />;
      case "Energia": return <FaBolt className="nav-icon" />;
      case "Software": return <FaWindows className="nav-icon" />;
      default: return <FaBars className="nav-icon" />;
    }
  };

  const handleSidePanelToggle = () => setPanelVisible((prev) => !prev);
  const handleSubmenuToggle = (category) => setOpenCategory((prev) => (prev === category ? null : category));

  const scrollToProducts = () => {
    setTimeout(() => {
      const productSection = document.getElementById("products-section");
      if (productSection) {
        productSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 200);
  };

  const handleCategoryClick = (category) => {
    setFilterCategory(category);
    setFilterSubcategory("");
    setPanelVisible(false);

    if (location.pathname !== "/") {
      navigate("/", { state: { scrollToProducts: true } });
    } else {
      scrollToProducts();
    }
  };

  const handleSubcategoryClick = (subcategory) => {
    setFilterSubcategory(subcategory);
    setPanelVisible(false);

    if (location.pathname !== "/") {
      navigate("/", { state: { scrollToProducts: true } });
    } else {
      scrollToProducts();
    }
  };

  return (
    <>
      {/* Navbar */}
      <Navbar expand="lg" className="custom-navbar-bottom1">
        <Navbar.Toggle aria-controls="navbar-nav-second-line" />
        <Navbar.Collapse id="navbar-nav-second-line">
          <Nav className="me-auto">
            <Nav.Link className="custom-dropdown1" onClick={handleSidePanelToggle}>
              <FaBars className="nav-icon" /> Produtos
            </Nav.Link>

            {/* Dropdowns com apenas 5 categorias */}
            <div className="d-none d-lg-flex">
              {navbarCategories.map((category) => (
                <Dropdown
                  key={category}
                  onMouseEnter={() => setOpenDropdown(category)}
                  onMouseLeave={() => setOpenDropdown(null)}
                  show={openDropdown === category}
                >
                  <Dropdown.Toggle
                    className="custom-dropdown1"
                    aria-haspopup="true"
                    aria-expanded={openDropdown === category}
                  >
                    {renderIcon(category)} {category}
                  </Dropdown.Toggle>
                  <Dropdown.Menu role="menu">
                    <Dropdown.Item role="menuitem" onClick={() => handleCategoryClick(category)}>
                      Todos {category}
                    </Dropdown.Item>
                    {categories[category].map((sub) => (
                      <Dropdown.Item key={sub} role="menuitem" onClick={() => handleSubcategoryClick(sub)}>
                        {sub}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              ))}
            </div>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* Máscara para fechar o painel lateral */}
      {isPanelVisible && <div className="sd-side-panel-mask" onClick={handleSidePanelToggle} />}

      {/* Painel lateral para mobile */}
      <div className={`sd-side-panel ${isPanelVisible ? "active" : ""}`}>
        <div className="side-panel-content">
          <h3 style={{ marginTop: "30px" }} className="painel">Produtos</h3>
          {panelCategories.map((category) => (
            <div className="sd-accordion-submenu" style={{ marginTop: "0px" }} key={category}>
              <div
                className="sd-accordion-submenu__item"
                onClick={() => handleSubmenuToggle(category)}
                role="button"
                aria-expanded={openCategory === category}
                tabIndex={0}
              >
                {renderIcon(category)} {category}
              </div>
              {openCategory === category && (
                <ul className="sd-accordion-submenu__list" role="menu">
                  <li role="menuitem" onClick={() => handleCategoryClick(category)}>
                    Todos {category}
                  </li>
                  {categories[category].map((sub) => (
                    <li key={sub} role="menuitem" onClick={() => handleSubcategoryClick(sub)}>
                      {sub}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
          <button className="sd-close-btn" onClick={handleSidePanelToggle}>Fechar</button>
        </div>
      </div>
    </>
  );
};

export default CustomNavbar;